/**
 * Builds the HTML for measurements
 * @param {Object} product
 */
const defineHTMLForMeasurements = product => {
    let measurementUnitsTemplate = "";
    const {id, measurementInfo} = product;

    if (typeof measurementInfo == "object" && measurementInfo != null && measurementInfo.quantityConversionRates && measurementInfo.quantityConversionRates.hasConversionRate && measurementInfo.quantityConversionRates.hasAlternativeSaleUnit) {
        const primaryMeasurementUnit = measurementInfo.quantityConversionRates.primaryunit;
        const secondaryMeasurementUnit = measurementInfo.quantityConversionRates.secondaryunit;
        measurementUnitsTemplate =
            `<div class="measurement-unit-section">
                <div class="pwc-form-radio">
                    <input type="radio" id="minicart-${secondaryMeasurementUnit}-${id}-measurement-unit" class="product-measurement-unit"
                        name="minicart-measurement-unit-${id}"
                        value="${secondaryMeasurementUnit}"
                        data-type="secondary"
                        title />
                    <label class="${secondaryMeasurementUnit}-label pwc-form-check-label" for="minicart-${secondaryMeasurementUnit}-${id}-measurement-unit">${secondaryMeasurementUnit}</label>
                    <span class="checkmark"></span>
                </div>
                <div class="pwc-form-radio">
                    <input type="radio" id="minicart-${primaryMeasurementUnit}-${id}-measurement-unit" class="product-measurement-unit"
                        name="minicart-measurement-unit-${id}"
                        value="${primaryMeasurementUnit}" data-type="primary"
                        checked="checked"
                        title />
                    <label class="${primaryMeasurementUnit}-label pwc-form-check-label" for="minicart-${primaryMeasurementUnit}-${id}-measurement-unit">${primaryMeasurementUnit}</label>
                    <span class="checkmark"></span>
                </div>
            </div>`;
    }

    return measurementUnitsTemplate;
};

/**
 * Return the variation element defined on variationValue
 * @param {Array} variationAttributes
 * @param {String} variationValue
 */
const filterVariations = (variationAttributes, variationValue) => {
    variationAttributes.filter(element => {
        return element.id == variationValue;
    });
};

export { defineHTMLForMeasurements, filterVariations };
